<script setup lang="ts">
    import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';

    defineProps<{
        employee: Employee;
        data: ChangedFields;
    }>();

    const values = computed(() => {
        return [
            { name: 'notice_date', group: 'termination', key: 'termination' },
            { name: 'termination_date', group: 'termination', key: 'termination' },
        ];
    });
</script>

<template>
    <EmployeeChangesGroup
        :data="data"
        :values="values"
        :employee="employee"
    />
</template>
